import './entryDetail.css'
import Popup from 'reactjs-popup';
import axios from "axios";
import React, {useEffect, useState,useContext } from "react";
import {useSearchParams } from 'react-router-dom';
import SglContext from '../SglContext'
import sgllogo from '../images/sgllogo.png'
import './entryDetail.css'

import { Link } from 'react-router-dom';
import video_icon from "../images/video_icon.png";
import VideoPlayer from "../videos/VideoPlayer";
import CheckoutPayment from '../actions/checkoutPayment';
import "../actions/checkout.css";


function EntryDetail(props){
  
    const Sgl = useContext(SglContext)
    const [entry_details, setEntry_details] = useState([])
    const [classes, setClasses] = useState([])
    const [entry_show, setEntry_show] = useState({})
    const [company_name, setCompany_name] = useState('')
    const [currentShow, setCurrentShow] = useState(localStorage.getItem('show_id'))
    const [userData, setUserData] = useState({})
    const [default_tab, setDefault_tab] = useState('classes')
    const [current_tab, setCurrent_tab] = useState('classes')
    const [sgl_show_id, setSgl_show_id] = useState(localStorage.getItem('show_id'))

    const [show_checkout, setShow_checkout] = useState(false)
    
    const [checkout_list, setCheckout_list] = useState([])
    const [selected_entries, setSelected_entries] = useState([])
    const [payment_methods, setPayment_methods] = useState([])
    const [can_checkout, setCanCheckout] = useState(true)
    const [bank_accounts, setBankAccounts] = useState([])
    const [ach_enabled, setACHEnabled] = useState(false)
    const [ach_service_fee_percent, setACHServiceFeePercent] = useState(0)
    const [ach_service_fee_cap, setACHServiceFeeCap] = useState(0)
    const [check_card_email_phone_info, setCheck_card_email_phone_info] = useState(false)
    const [check_address_info, setCheck_address_info] = useState(false)
    const [show_name, setShow_name] = useState('')
    const [VideoSubscriptionElement, setVideoSubscriptionElement] = useState(null);
    const [show_number, setShow_number] = useState('')
    const [show_start_date, setShow_start_date] = useState('')
    const [is_rider, setIs_rider] = useState(false)
    const [smc_payment, setSmc_payment] = useState({})
    const [people_id, setPeople_id] = useState(0)
    const [people_ids, setPeopleIds] = useState([])
    const [check_payment_method_info, setCheck_payment_method_info] = useState(false)
    const [isResponsible, setIsResponsible] = useState(false);
    
    const [payment_error, setPayment_error] = useState('')
    const [payment_success, setPayment_success] = useState(true)
    
    const [entry_prices_list, setEntry_prices_list] = useState([])
    const [account_entry, setAccount_entry] = useState({})
    const [entry_fees_list, setEntry_fees_list] = useState([])
    const [trainer_split_list, setTrainer_split_list] = useState([])
    const [payment_entries_list, setPayment_entries_list] = useState([])
    const [placings_list, setPlacings_list] = useState([])
    
    const [videos_list, setVideos_list] = useState([])
    const [is_videos_enabled, setIs_videos_enabled] = useState(false)
    const [video_to_play, setVideo_to_play] = useState({})
    const [playing_video, setPlaying_video] = useState(false)
    const [is_open_play_video_modal, setIs_open_play_video_modal] = useState(false)
    const [is_open_do_subscription_modal, setIs_open_do_subscription_modal] = useState(false)
    const [VideoPlayerElement, setVideoPlayerElement] = useState(null);



    const [is_admin, setIs_admin] = useState(false)
    const [loading, setLoading] = useState(true)

    const [searchParams, setSearchParams] = useSearchParams()

    const [edit_entry_switch, setEditSwitch] = useState(0);
    // Api EndPoints
    const sgl_webservice_iphone = Sgl.sglApiUrl+'/iphonev2/addentryv2/';
    const sgl_webservice_checkout = Sgl.sglApiUrl+'/iphonev2/checkoutv2/';
    var sgl_webservice_entry_detail = Sgl.nestApiUrl+'/entries/';
    const user_info_url = Sgl.nestApiUrl+'/users/getUser';
    const sgl_webservice_video_to_play = Sgl.nestApiUrl + "/videos/play/";

    useEffect(() => {
        axios.get(sgl_webservice_entry_detail + searchParams.get('eid'), {
          params: {
            eid: searchParams.get('eid'),
            show_id: searchParams.get('sid'),
            customer_id: Sgl.company_id,
            team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
          }
        }
        ).then(res => {
          setEntry_details(res.data.entry)
          setClasses(res.data.classes)
          setCompany_name(res.data.company_name)
          setEntry_show(res.data.entry_show)
          setIs_videos_enabled(res.data.is_videos_enabled)
          setCurrentShow(res.data.show_id)
          setIsResponsible(res.data.is_responsible);
          getPaymentMethods();
          getCheckoutData(res.data.show_id)
          // getEntryDetails()
          getUserData()
          getEntryVideos()
          getAccountDetails()
          // setShow_checkout(true)
          setLoading(false)
          if ( !res.data.is_responsible ) {
            document.getElementById("classesTab")?.click();
          }
          localStorage.setItem('show_id', res.data.show_id);
          document.title = "Entry " + res.data.entry.number + " - " + res.data.entry.horse + " " + current_tab;
          Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+sgl_show_id+'/entries/detail/'+searchParams.get('eid'));
          Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+sgl_show_id+'/entries/detail/'+searchParams.get('eid'));
        })

        var edit_entry_switch = Sgl.switches.switches.find( el => el.switch_name == "Edit Entry");
        if(edit_entry_switch){
          setEditSwitch(edit_entry_switch.value);
        }
      }, [Sgl.currentTeamId, searchParams.get('eid'), searchParams.get('sid')])
    function getEntryDetails(){
      axios.all([
        axios.get(sgl_webservice_entry_detail+searchParams.get('eid'),{
          params : {
              eid: searchParams.get('eid'),
              show_id: searchParams.get('sid'),
              customer_id: Sgl.company_id
          }
        })
      ]).then(axios.spread((res) => {
            setEntry_details(res.data.entry)
            setClasses(res.data.classes)
            setCurrentShow(res.data.show_id)
            setEntry_show(res.data.entry_show)
            setCompany_name(res.data.company_name)
            setIs_videos_enabled(res.data.is_videos_enabled)
            setLoading(false)
        // })
        localStorage.setItem('show_id', res.data.show_id);
        document.title = "Entry " + res.data.entry.number + " - " + res.data.entry.horse + " " + current_tab;
        Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+sgl_show_id+'/entries/detail/'+searchParams.get('eid'));
        Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+sgl_show_id+'/entries/detail/'+searchParams.get('eid'));
      }))
    }
    function getEntryVideos(){
      axios.get(sgl_webservice_entry_detail+'videos/'+searchParams.get('eid'),{
          params : {
              show_id: sgl_show_id,
              customer_id: Sgl.company_id
          }
        })
      .then((res) => {
          setVideos_list(res.data.exc_videos)
      });
    }
    function getUserData(){
      axios.get(Sgl.nestApiUrl+'/users/getUser')
      .then((response) => {
        localStorage.setItem("userTeams", JSON.stringify(response.data.userTeams));
        if(response.data.user && response.data.user != null){
          Sgl.checkLoginOnSGL();
          setUserData(response.data.user)
          setShow_checkout(true)
          if(localStorage.getItem('playing_video_id') && localStorage.getItem('playing_video_url') == window.location.pathname.replace(Sgl.basePath, '') + window.location.search){
            playVideoAPICall(localStorage.getItem('playing_video_id'));  
          }
        }else{
        }
      }, (error) => {
      });
    }
/////// video functions /////////////


    const playVideo = (video_id) => (e) => {
      playVideoAPICall(video_id);
    }
    function playVideoAPICall(video_id){
      
      localStorage.setItem('playing_video_id', video_id);
      localStorage.setItem('playing_video_url', window.location.pathname.replace(Sgl.basePath, '') + window.location.search);
      axios.get(sgl_webservice_video_to_play+video_id,{
        params : {
            // show_id: sgl_show_id,
            customer_id: Sgl.company_id
        }
      })
      .then((res) => {
        closeSubscriptionModal();
        localStorage.removeItem("playing_video_id");
        localStorage.removeItem("playing_video_url");
        if (res.data.subscribed_to_play){
          setVideo_to_play(res.data.video)
          setIs_admin(res.data.is_admin)
          setIs_open_play_video_modal(true)
          setPlaying_video(true)
        } else {
          setVideo_to_play(res.data.video)
          setIs_admin(res.data.is_admin)
          setIs_open_do_subscription_modal(true)
          setPlaying_video(true)
        }
      });
    }

    const closeModal=()=> {
      setIs_open_play_video_modal(false)
      setPlaying_video(false)
    }

    function closeSubscriptionModal() {
      setIs_open_do_subscription_modal(false)
      setPlaying_video(false)
      
    }
    function playVideoAfterSubscribe(){
      playVideoAPICall(video_to_play.videos_sgl_id);
      setPlaying_video(true)
    }
    
    function getVideoTitle(video){
      if(video['class_type'] == 'Jumpers'){
        if(video['trip_type'].toLowerCase() != 'jo'){
          return " - Round 1";
        }else{
            return " - Jump Off";
        }
      }
    }
    //////////// end video functions ///////
    // ///////// checkout functions ////////
    function getPaymentMethods(props){
      axios.get(sgl_webservice_iphone+'GetPaymentMethods',{
        params : {
            company_id: Sgl.company_id,
            team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
        }
      }).then(result => {
          setPayment_methods (result.data.payment_methods?result.data.payment_methods:[])
          setCanCheckout(result.data.can_checkout)
          setBankAccounts (result.data.bank_accounts?result.data.bank_accounts:[])
          setCheck_card_email_phone_info (result.data.check_card_email_phone_info)
          setCheck_address_info (result.data.check_address_info)
          setLoading(false)
      })
    }
    function getCheckoutData(show){
      axios.get(sgl_webservice_checkout+'Index',{
        params : {
            includeAll : false,
            show_id : show,
            customer_id: Sgl.company_id,
            team_id: Sgl.currentTeamId != 'personal'?Sgl.currentTeamId:0,
            id: searchParams.get('eid')
        }
      }).then(res => {
        var entries = res.data.entries?res.data.entries:[];
        const entries_list = entries.map((entry) => {
          return {...entry, 'expanded': false};
        });
        
          setACHEnabled(res.data.ach_enabled)
          setACHServiceFeePercent(res.data.ach_service_fee_percent)
          setACHServiceFeeCap(res.data.ach_service_fee_cap)
          setCheckout_list(entries_list)
          setShow_name(res.data.show_name)
          setShow_number(res.data.show_number)
          setShow_start_date(res.data.start_date)
          setIs_rider(res.data.isRider)
          setCheck_payment_method_info(res.data.check_payment_method_info)
          setSmc_payment(res.data.smc_payment? res.data.smc_payment: {})
          setPeople_id (res.data.people_id)
          setPeopleIds (res.data.people_ids)
          setSelected_entries([])
      })
    }
    function getAccountDetails(){
      axios.get(sgl_webservice_checkout+'AccountDetail',{
        params : {
            customer_id: Sgl.company_id,
            aid: searchParams.get('eid')
        }
      }).then(res => {
          setAccount_entry(res.data.entry[0])
          setEntry_fees_list(res.data.entryFees)
          setEntry_prices_list(res.data.entryPrices)
          setTrainer_split_list(res.data.PaymentXEntries_Trainer_Split)
          setPayment_entries_list(res.data.paymentEntries)
          setPlacings_list(res.data.entryPlacings)
      })
    }
    function getVideosList(uuid){
      var trip = videos_list.find(v => (v.uuid == uuid));
      if(trip) {
        var videos = trip.videos;
        return videos;
      }
      return [];
    }

    function playFirstVideoFromList(uuid){
      var trip = videos_list.find(v => (v.uuid == uuid));
      if(trip) {
        playVideoAPICall(trip.videos[0].sgl_id)
      }
      return;
    }

    function updateSelectedEntries(entries_list){
      setSelected_entries(entries_list);
    }
    function updateCheckoutList(entries_list){
      setCheckout_list(entries_list)
    }
    function getPaymentDescription(){
      var desc = show_number;
      if (!show_start_date || show_start_date == '0000-00-00'){
          desc = desc;
      } else {
        var formatted_date = (new Date(show_start_date));
        var year = formatted_date.getFullYear().toString().substr(-2);
        desc = desc + '-' + year;
      }
      selected_entries.forEach(entry => {
        desc = desc + ' ' + entry.number;
      });
      return desc;
      
    }

    function showPaymentResults(results){
      document.getElementById('payment_result').style.display = "block";
      document.getElementById('payment_details').style.display = "none";
      setPayment_error(results.error)
      setPayment_success(results.success)
      // setPayment_error()
      updateSelectedEntries([]);
    }

    const backToCheckout = () => (e) => {
      document.getElementById('payment_result').style.display = "none";
      document.getElementById('payment_details').style.display = "block";
      setPayment_error('')
      setPayment_success(true)
      getCheckoutData(currentShow)
    }
    //////////// end checkout functions //////////////

    function format_date(unformatted_date){
      if(unformatted_date){
        var unformatted_date_split = (unformatted_date && unformatted_date.split)?unformatted_date.split('T')[0]:unformatted_date;
        var formatted_date = (new Date(unformatted_date_split));
        formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
        var unformatted_month = formatted_date.getMonth()+1;
        return ((unformatted_month < 10) ? '0' + unformatted_month.toString() : unformatted_month.toString()) +"/"+ ((formatted_date.getDate() < 10) ? '0' + formatted_date.getDate() : formatted_date.getDate()) +"/"+ formatted_date. getFullYear()%100;
      }
      return;
      }

      function format_time(timeString){
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = (H < 12 || H === 24) ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }

    function format_phone(num) {
      if(num){
        num = num.replace(/[^0-9]/, '');
        var len = num.length;

        if (len == 7) {
            num = num.replace(/([0-9]{3})([0-9]{4})/, '$1-$2');
        } else if (len == 10){
          num = num.replace(/([0-9]{3})([0-9]{3})([0-9]{4})/, '($1) $2-$3');
        } else if (len == 11){
            num = num.replace(/([0-9]{1})([0-9]{3})([0-9]{3})([0-9]{4})/, '+$1($2) $3-$4');
        }
      }

      return num;
    }

    function onShowChange(show_id) {
      localStorage.setItem('show_id', show_id);
      // window.location.href=page_url;
    }
    
    function getDefaultDisplay(tab){
      if(default_tab == tab){
        return ' display_block';
      }
      return ' display_none';
    }

    function getDefaultTab(tab){
      if(default_tab == tab){
        return ' active';
      }
      return '';
    }

    const openTab = (tabName) => (e) => {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(tabName).style.display = "block";
      e.currentTarget.className += " active";
      setCurrent_tab(tabName)
    }

    function getTotalFee(){
      let sum = entry_prices_list.reduce(function(prev, current) {
          return prev + +current['price']
        }, 0);
        return sum;
    }
    function getTotalEntryFee(){
      let sum = entry_fees_list.reduce(function(prev, current) {
          return prev + +current['totalprice']
        }, 0);
        return sum;
    }
    function getTotalTrainerSplitAmount(){
      let sum = trainer_split_list.reduce(function(prev, current) {
          return prev + +Math.abs(current['amount_applied'])
        }, 0);
        return sum;
    }
    function getTotalPaymentAmount(){
      let sum = payment_entries_list.reduce(function(prev, current) {
          return prev + +current['amount_applied']
        }, 0);
        return sum;
    }

    function format_currancy(amount){
      if(amount == 0){
        return '$0.00';
      }
      if(amount == undefined || amount == ''){
        return '';
      }
      return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));

    }

        if(loading) {
          return null;
        }
        
        return(
          <div id='section-to-print' className=" sgl-plugin section-to-print entry-details-css">
              <div className='print_block '>
                <h2 className='sgl-add_entry print-header'>
                  <span>{company_name.name + ' - Statement'}</span>
                  <br></br>
                  <span>{entry_show.show_name}</span>
                  <br></br>
                  <span>{entry_show.city + ' ' + entry_show.state + ' ' + entry_show.postal_code}</span>
                  <br></br>
                  <span>{format_phone(entry_show.phone)}</span>
                  <br></br>
                  <span>{format_date(entry_show.start_date) + ' to ' + format_date(entry_show.end_date) }</span>
                </h2>
              </div>
              <div className='buttons-div'>
                <h2 className='entry_head'>Entry {entry_details.number} - {entry_details.horse}</h2>
                {(isResponsible) &&
                  <div className="no_print">
                    {(!entry_details.trainer_account && !entry_details.scratched) &&
                      // <button className='sgl-button mr-r-5'>
                      <Link to={'/class-adds-drops/?entry_id='+searchParams.get('eid')}>
                      <button className='sgl-button mr-r-5 entry_action_btn'>
                        Class Add/Drops
                      </button>
                      </Link>
                    }
                    {(!entry_details.scratched) &&
                    <Link to={'/order-supplies/?entry_id='+searchParams.get('eid')}>
                      <button className='sgl-button mr-r-5 entry_action_btn'>
                        
                        Order Supplies
                      </button>
                      </Link>
                    }
                    { (current_tab == 'AccountDetail') &&
                      <button className='sgl-button mr-r-5 entry_action_btn' onClick={() => window.print()}>Print Invoice</button>
                    }
                  </div>
                }
              </div>
              <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br/>
              <table className="table contains-border">
                <thead className="entry-detail-header">
                    <tr className="sgl-primary-header">
                      <th colspan="6">Entry Details</th>
                    </tr>
                </thead>
                <tbody>
                  
                  <tr>
                    <th colspan="1" className="details-table-head">Entry:</th>
                    <td colspan="2">{entry_details.number}
                      {
                          ( people_ids && people_ids.length > 0 && people_ids.map(Number).includes(entry_details.trainer_id) && edit_entry_switch ) && 
                          <Link style={{ marginLeft : "10px", float: "right" }} to={`/edit-entry/?eid=${entry_details.entry_id}&sid=${currentShow}`}>
                            Modify
                          </Link>                        
                      } 
                    </td>
                  </tr>
                  <tr>
                    <th colspan="1" className="details-table-head">Horse:</th>
                    <td colspan="2">{entry_details.horse}</td>
                  </tr>
                  <tr>
                    <th colspan="1" className="details-table-head">Riders</th>
                    <td colspan="2">{entry_details.rider_list}
                      {
                          ( people_ids && people_ids.length > 0 && people_ids.map(Number).includes(entry_details.trainer_id) && edit_entry_switch ) && 
                          <Link style={{ marginLeft : "10px", float: "right" }} to={`/edit-entry/?eid=${entry_details.entry_id}&sid=${currentShow}`}>
                            Add/Change
                          </Link>                        
                      } 
                    </td>
                  </tr>
                  <tr>
                    <th colspan="1" className="details-table-head">Owner:</th>
                    <td colspan="2"><Link to={'/people/detail?pid='+entry_details.entryowner_id+'&sid='+currentShow}>{entry_details.owner}</Link></td>
                  </tr>
                  <tr>
                    <th colspan="1" className="details-table-head">Trainer:</th>
                    <td colspan="2"><Link to={'/people/detail?pid='+entry_details.trainer_id+'&sid='+currentShow}>{entry_details.trainer}</Link></td>
                  </tr>
                  <tr className='print-tr'>
                    <th colspan="1" className="details-table-head">Prize Money Recipient:</th>
                    <td colspan="2">{(account_entry?.prizemoneyrecipient)?account_entry.prizemoneyrecipient:'N/A'}</td>
                  </tr>
                  <tr className='print-tr'>
                    <th colspan="1" className="details-table-head">Responsible Party:</th>
                    <td colspan="2">{(account_entry?.responsibleparty)?account_entry.responsibleparty:'N/A'}</td>
                  </tr>
                </tbody>
              </table>
              <div className="tab no_print">
                  <button id='classesTab' className={["tablinks", getDefaultTab('classes')].join(' ')} onClick={openTab('Classes')}>Classes</button>
                  {(show_checkout && isResponsible) &&
                    <button className={["tablinks", getDefaultTab('accountdetail')].join(' ')} onClick={openTab('AccountDetail')}>Account Detail</button>
                  }
                  {(show_checkout && isResponsible && can_checkout) &&
                    <button className={["tablinks", getDefaultTab('checkout')].join(' ')} onClick={openTab('Checkout')}>Checkout</button>
                  }
              </div>

              <div id="Classes" className={["tabcontent", getDefaultDisplay('classes')].join(' ')}>
                { (classes.length > 0) ?
                  <div className="div-responsive">
                    
                    <table className="table table-striped">
                      <tbody>
                        <tr className="sgl-primary-header">
                          { (is_videos_enabled == true) &&
                            <th nowrap="nowrap"></th>
                          }
                          <th nowrap="nowrap" className='center-align'>Number</th>
                          <th nowrap="nowrap">Name</th>
                          <th nowrap="nowrap">Rider</th>
                          <th nowrap="nowrap" className='center-align'>Count</th>
                          <th nowrap="nowrap" className='center-align'>Placing</th>
                          <th nowrap="nowrap" className='center-align'>Ring</th>
                          <th nowrap="nowrap" className='center-align'>Day</th>
                          <th nowrap="nowrap" className='center-align'>Est. Start</th>

                        </tr>
                        {
                          classes.map((data,index) => { 
                            return(
                              <tr key={index} className='sgl-anchor '>
                              {/* // <tr className={[data.scratch_trip?'strike_out':'', 'sgl-anchor'].join(' ')}> */}          
                      
                                { (is_videos_enabled == true) &&
                                  <td><a>
                                    {(getVideosList(data.entryxclasses_uuid).length > 0) ?
                                      <Popup trigger={<img src={video_icon} className="video-icon" onClick={()=>playFirstVideoFromList(data.entryxclasses_uuid)}/>} position="right center" on="hover">
                                        <div>
                                          <ul className='popup-ul'>
                                            {getVideosList(data.entryxclasses_uuid).map((v_data,index) => { 
                                              return(
                                                <li key={index} className='class_list_li'><a onClick={playVideo(v_data.sgl_id)} >{v_data.class_number} - {v_data.class_name}{getVideoTitle(v_data)}</a></li>
                                              )
                                            })}
                                          </ul>
                                        </div>
                                      </Popup>
                                    :
                                      ''
                                    }
                                  </a></td>
                                }
                                <td className='center-align' nowrap="nowrap"><Link to={'/classes/detail?cid='+data.class_id+'&sid='+currentShow}>{data.class_number}</Link></td>
                                <td><Link to={'/classes/detail?cid='+data.class_id+'&sid='+currentShow}>{data.name}{((data.sponsor) ? <span className='sponsor_text new-line'> <br/>(Sponsored By: {data.sponsor})</span>:"")}</Link></td>
                                <td><Link to={'/people/detail?pid='+data.rider_id+'&sid='+currentShow}>{data.rider_name}</Link></td>
                                <td className='center-align'><Link to={'/people/detail?pid='+data.rider_id+'&sid='+currentShow}>{data.count}</Link></td>
                                <td className='center-align'><Link to={'/people/detail?pid='+data.rider_id+'&sid='+currentShow}>{data.placing}</Link></td>
                                <td className='center-align'><Link to={'/people/detail?pid='+data.rider_id+'&sid='+currentShow}>{data.ring}</Link></td>
                                <td className='center-align' nowrap="nowrap"><Link to={'/people/detail?pid='+data.rider_id+'&sid='+currentShow}>{((data.scheduled_date !== '0000-00-00') ? (format_date(data.scheduled_date)) : '' )}</Link></td>
                                <td className='center-align'><Link to={'/people/detail?pid='+data.rider_id+'&sid='+currentShow}>{((data.schedule_starttime !== '00:00:00') ? (format_time(data.schedule_starttime)) : '' )}</Link></td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                :
                  <div><span>Not scheduled in any class</span></div>
                }
              </div>

              <div id="AccountDetail" className={["tabcontent", "", getDefaultDisplay('accountdetail')].join(' ')}>
                <label className="sgl-label-border sgl-add_entry"><h2>Class Fee</h2></label>
                <div className="" style={{overflowX: "auto"}}> 
                  { (entry_prices_list.length > 0) ?
                    <table  style={{width: "100%"}} className="table table-striped table-hover">
                        <tbody>
                            <tr className="sgl-primary-header">
                              <th className="">Description</th>
                              <th className="right-align">Price</th>
                            </tr>
                        {/* </thead> */}
                        {/* <tbody> */}
                            {entry_prices_list.map((data, index) => {
                                return [
                                  <tr key={index}>
                                    <td className="">{data.description}</td>
                                    <td className="right-align price_column">{format_currancy(data.price)}</td>
                                  </tr>
                                ]
                              })
                            
                            }
                            <tr>
                              <td className=""><strong>Total</strong></td>
                              <td className="right-align"><strong>{format_currancy(getTotalFee())}</strong></td>
                            </tr>
                            
                        </tbody>
                    </table>
                  :
                      <p> No classes found </p>

                  }
                </div>

                <label className="sgl-label-border sgl-add_entry"><h2>Misc. Fee</h2></label>
                <div style={{overflowX: "auto"}}> 
                  { ((trainer_split_list.length + entry_fees_list.length) > 0) ?
                    <table  style={{width: "100%"}} className="table table-striped table-hover">
                        <tbody>
                            <tr className="sgl-primary-header">
                              <th className="display_on_mobile">Details</th>
                              <th className="display_on_desktop">Date</th>
                              <th className='display_on_desktop center-align'>Qty.</th>
                              <th className="display_on_desktop">Description</th>
                              <th className="display_on_desktop right-align">Unit Price</th>
                              <th className='display_on_desktop center-align'>Tax Abbr.</th>
                              <th className="right-align price_column">Total Price</th>
                            </tr>
                        {/* </thead> */}
                        {/* <tbody> */}
                            
                            {entry_fees_list.map((data, index) => {
                                return [
                                  <tr key={index}>
                                    <td className="display_on_mobile mbl_custom_row new-line">
                                      <p className="table_row_p">
                                        <span><strong>Date:</strong>{format_date(data.date)}</span>
                                        <br></br>
                                        <span><strong>Qty.:</strong> {Number(data.quantity)}</span>
                                        <br></br>
                                        <span><strong>Description:</strong> {data.description}</span>
                                        <br></br>
                                        <span><strong>Unit Price:</strong> {format_currancy(data.unitprice)}</span>
                                        <br></br>
                                        <span><strong>Tax Abbr:</strong> {(data.show_tax_rate_abbr)?data.show_tax_rate_abbr:'-'} </span>
                                        
                                      </p>
                                    </td>
                                    <td className="display_on_desktop">{format_date(data.date)}</td>
                                    <td className='display_on_desktop center-align'>{Number(data.quantity)}</td>
                                    <td className="display_on_desktop">{data.description}</td>
                                    <td className="display_on_desktop right-align">{format_currancy(data.unitprice)}</td>
                                    <td className="display_on_desktop center-align">{(data.show_tax_rate_abbr)?data.show_tax_rate_abbr:'-'}</td>
                                    <td className="right-align">{format_currancy(data.totalprice)}</td>
                                  </tr>
                                ]
                              })
                            }
                            {trainer_split_list.map((data, index) => {
                                return [
                                  <tr key={index}>
                                    <td className="display_on_mobile mbl_custom_row new-line">
                                      <p className="table_row_p">
                                        <span><strong>Date:</strong>{format_date(data.Payments.payment_date)}</span>
                                        <br></br>
                                        <span><strong>Qty.:</strong>1</span>
                                        <br></br>
                                        <span><strong>Description:</strong> {data.Payments.description}</span>
                                        <br></br>
                                        <span><strong>Unit Price:</strong> {format_currancy(Math.abs(data.amount_applied))}</span>
                                        <br></br>
                                        <span><strong>Tax Abbr:</strong> - </span>
                                        
                                      </p>
                                    </td>
                                    <td className="display_on_desktop">{format_date(data.Payments.payment_date)}</td>
                                    <td className='center-align display_on_desktop'>1</td>
                                    <td className='display_on_desktop'>{data.Payments.description}</td>
                                    <td className="right-align display_on_desktop">{format_currancy(Math.abs(data.amount_applied))}</td>
                                    <td className="center-align display_on_desktop">-</td>
                                    <td className="right-align display_on_desktop">{format_currancy(Math.abs(data.amount_applied))}</td>
                                  </tr>
                                ]
                              })
                            }
                            <tr>
                              <td className="display_on_mobile"><strong>Total</strong></td>
                              <td colspan="5" className="display_on_desktop"><strong>Total</strong></td>
                              <td className="right-align"><strong>{format_currancy(getTotalEntryFee() + getTotalTrainerSplitAmount())}</strong></td>
                            </tr>
                            <tr>
                              <td className="display_on_mobile"><strong>Sales Tax</strong></td>
                              <td  colspan="5" className="display_on_desktop"><strong>Sales Tax</strong></td>
                              <td className="right-align"><strong>{format_currancy(account_entry?.tax)}</strong></td>
                            </tr>
                            <tr>
                              <td className="display_on_mobile"><strong>Total Fees</strong></td>
                              <td  colspan="5" className="display_on_desktop"><strong>Total Fees</strong></td>
                              <td className="right-align"><strong>{format_currancy(Number(account_entry?.total_fees) + getTotalTrainerSplitAmount())}</strong></td>
                            </tr>
                            
                        </tbody>
                    </table>
                  :
                      <p> No Misc. Fees Found </p>

                  }
                </div>
                
                <label className="sgl-label-border sgl-add_entry"><h2>Payments</h2></label>
                <div style={{overflowX: "auto"}}> 
                  { (payment_entries_list.length > 0) ?
                    <table style={{width: "100%"}} className="table table-striped table-hover">
                        <tbody>
                            <tr className="sgl-primary-header" >
                              <th className="display_on_mobile">Payments</th>
                              <th className="display_on_desktop">Date</th>
                              <th className="display_on_desktop">Type</th>
                              <th className="display_on_desktop">Description</th>
                              <th className="right-align price_column">Amount</th>
                            </tr>
                        {/* </thead> */}
                        {/* <tbody> */}
                            {payment_entries_list.map((data, index) => {
                                return [
                                  <tr key={index}>
                                    <td className="display_on_mobile mbl_custom_row new-line">
                                      <p className="table_row_p">
                                        <span><strong>Date:</strong>{format_date(data.payment.payment_date)}</span>
                                        <br></br>
                                        <span><strong>Type:</strong>{data.payment.type}</span>
                                        <br></br>
                                        <span><strong>Description:</strong> {data.payment.description}</span>
                                        
                                      </p>
                                    </td>
                                    <td className="display_on_desktop">{format_date(data.payment.payment_date)}</td>
                                    <td className="display_on_desktop">{data.payment.type}</td>
                                    <td className="display_on_desktop">{data.payment.description}</td>
                                    <td className="right-align">{format_currancy(data.amount_applied)}</td>
                                  </tr>
                                ]
                              })
                            
                            }
                            <tr>
                              <td className="display_on_mobile"><strong>Total</strong></td>
                              <td colspan="3" className="display_on_desktop"><strong>Total</strong></td>
                              <td className="right-align"><strong>{format_currancy(getTotalPaymentAmount())}</strong></td>
                            </tr>
                            
                        </tbody>
                    </table>
                  :
                      <p> No Payments Found </p>

                  }
                </div>
                <label className="sgl-label-border sgl-add_entry "><h2>Placings</h2></label>
                <div style={{overflowX: "auto"}}> 
                  { (placings_list.length > 0) ?
                    <table style={{width: "100%"}} className="table table-striped table-hover">
                        <tbody>
                            <tr className="sgl-primary-header">
                              <th>Class #</th>
                              <th>Name</th>
                              <th>Rider</th>
                              <th className="center-align">Place</th>
                              <th className="right-align">Prize $</th>
                            </tr>
                        {/* </thead> */}
                        {/* <tbody> */}
                            {placings_list.map((data, index) => {
                                return [
                                  <tr key={index}>
                                    <td className="">{data.Classes.number}</td>
                                    <td>{data.Classes.name}</td>
                                    <td>{data.rider_name}</td>
                                    <td className="center-align">{data.placing}</td>
                                    <td className="right-align">{format_currancy(data.total_prize_money)}</td>
                                  </tr>
                                ]
                              })
                            
                            }                            
                        </tbody>
                    </table>
                  :
                      <p> No Placings Found </p>
                  }
                </div>
                <label className="sgl-label-border sgl-add_entry "><h2>Notes</h2></label>
                <div style={{overflowX: "auto"}}> 
                  { (account_entry?.entry_notes) ?
                    <p> {account_entry?.entry_notes} </p>
                  :
                      <p> No Notes Found </p>

                  }
                </div>
                
                <div className='print-balance'>
                  {/* {(!is_mobile) && */}
                    <button className='sgl-button no_print' onClick={() => window.print()}>
                      Print Invoice
                    </button>
                  {/* } */}
                  <div className="total">
                    <span>Balance Due</span><strong>{format_currancy(account_entry?.balance)}</strong>
                  </div>                                    
                </div>
                <div className="print_block" style={{clear: "both"}}>
                  <strong className="print_block">Please Note- Prize money will not apply unless there is a Social Security Number or TIN for the prize money </strong>
                </div>
                <div id="print_footer" className="print_block print_footer">
                  <span>
                    <img className='footer_logo' src={sgllogo} />Copyright © {(new Date().getFullYear())} · All rights reserved · ShowGrounds, LLC. · Shelburne Falls MA · 1-888-429-9495      
                  </span>
                </div>
                    
              </div>

              <div id="Checkout" className={["tabcontent", getDefaultDisplay('checkout')].join(' ')}>
                <div id='payment_details'>
                  { (checkout_list.length > 0) &&
                    <CheckoutPayment 
                      selected_entries = {selected_entries} 
                      checkout_list = {checkout_list} 
                      updateSelectedEntries = {updateSelectedEntries} 
                      updateCheckoutList = {updateCheckoutList}
                      include_all_shows = {false} 
                      payment_methods = {payment_methods} 
                      ach_enabled = {ach_enabled}
                      ach_service_fee_percent = {ach_service_fee_percent}
                      ach_service_fee_cap = {ach_service_fee_cap}
                      bank_accounts = {bank_accounts}
                      check_card_email_phone_info = {check_card_email_phone_info} 
                      check_address_info = {check_address_info}
                      payment_description = {getPaymentDescription()}
                      getPaymentMethods = {getPaymentMethods}
                      smc_payment = {smc_payment}
                      current_show = {currentShow}
                      showPaymentResults = {showPaymentResults}
                      check_payment_method_info = {check_payment_method_info}
                      can_checkout = {can_checkout}
                      // ref = {CheckoutPaymentElement}
                    />

                  }
                </div>
                <div id='payment_result' className='display_none'>
                  {(payment_success) ? 
                      <p>Thank you! Payment has been submitted successfully.</p>
                  :
                      <p>Transaction Declined: {payment_error}</p>
                  }
                  <button className='sgl-button' onClick={backToCheckout()}>
                      Back to Checkout
                  </button>
                </div>
              </div>
              <div>
                {(playing_video) &&
                    <VideoPlayer 
                      is_open_play_video_modal = {is_open_play_video_modal} 
                      is_open_do_subscription_modal = {is_open_do_subscription_modal}
                      is_download_subscription = {false}
                      video_to_play = {video_to_play} 
                      is_admin = {is_admin}
                      closeModal = {closeModal} 
                      closeSubscriptionModal = {closeSubscriptionModal} 
                      playing_preview = {false} 
                      play_video_path = {video_to_play.video_url}
                      playVideoAfterSubscribe = {playVideoAfterSubscribe}
                      VideoSubscriptionElement = {VideoSubscriptionElement}
                      ref = {VideoPlayerElement}
                    />
                }
              </div>
              <div className="copyright-text no_print">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
          </div>
        )
}
export default EntryDetail